import GroupFilterSelectorContainer from './containers/GroupFilterSelectorContainer'

export default GroupFilterSelectorContainer
